:host {
  display: block;
}
.wrapper {
  display: flex;
  width: 100%;
  border-bottom: 1px solid #e5e5e5;
  background-color: #344861;
}

.titleWrapper {
  flex: 1;
  margin-left: 16px;
  color: white
}

body {
  margin: 0;
  font-family: sans-serif;
  padding: 0;
}

.container {
  /* margin: 16px; */
  padding: 16px;
  background-color: rgb(249, 249, 249);
}